module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('Elements_Input', {
		configure: function (options) {
			console.group('Elements_Input configure');
				console.log(options)
			console.groupEnd();
		},

		setProperties: function (properties) {
			this.elem = properties.elem;
			this.tagName = properties.tagName;
			this.type = properties.type;
			this.name = properties.name;

			return this;
		},

		getValue: function () {
			return this.elem.value;
		},

		setValue: function () {
			this.elem.value = val;

			return this;
		}
	});

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/form/elements/input.js
// module id = 194
// module chunks = 0